import { render } from "./jiaoshou.vue?vue&type=template&id=53824660&scoped=true"
import script from "./jiaoshou.vue?vue&type=script&lang=js"
export * from "./jiaoshou.vue?vue&type=script&lang=js"

import "./jiaoshou.vue?vue&type=style&index=0&id=53824660&scoped=true&lang=css"

import exportComponent from "C:\\Users\\33043\\Desktop\\new\\pc_admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53824660"]])

export default __exports__